document.addEventListener('DOMContentLoaded', function() {
  const popupOverlay = document.querySelector('.popup-form-overlay');
  const contactButton = document.querySelector('.contact-popup-button');
  const getintouchButton = document.querySelector('.getintouch-button');
  const calluslink = document.querySelector('.calluslink');
  const closeButton = document.querySelector('.popup-close-button');

  if (contactButton) {
    contactButton.addEventListener('click', function() {
      popupOverlay.style.display = 'flex';
    });
  }

  if (getintouchButton) {
    getintouchButton.addEventListener('click', function() {
      popupOverlay.style.display = 'flex';
    });
  }

  if (calluslink) {
    calluslink.addEventListener('click', function() {
      popupOverlay.style.display = 'flex';
    });
  }

  closeButton.addEventListener('click', function() {
    popupOverlay.style.display = 'none';
  });

  popupOverlay.addEventListener('click', function(event) {
    if (event.target === popupOverlay) {
      popupOverlay.style.display = 'none';
    }
  });
});